import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";

export const getFechasCierre = async (IdReferencia) => {
    const result = await PrivateInterceptor(`Base/CalendarioFinanzas/FechasCierre`, 'POST', {IdReferencia })
    return result
}